var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dash Header"},[_c('a-breadcrumb',_vm._l((_vm.pages),function(page){return _c('a-breadcrumb-item',{key:page.name},[_c('router-link',{attrs:{"to":page.route}},[_vm._v(_vm._s(page.name))])],1)}),1),_c('a-divider',[_c('h2',{style:({ textTransform: 'capitalize' }),domProps:{"innerHTML":_vm._s(_vm.dashboardTitle)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }